import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["link", "result"]
  }

  static get values() {
    return {
      email: String,
      track: String,
      trackGaCategory: String,
      trackGaAction: String,
    }
  }

  connect() {
    if (this.hasLinkTarget) {
      this.linkTarget.addEventListener("click", this.verifyEmail.bind(this))
    }
  }

  verifyEmail() {
    if (! this.hasEmailValue) {
      return
    }

    const _this = this
    const verification_link_tag = $(this.linkTarget)
    const verification_result_tag = $(this.resultTarget)
    const email = this.emailValue

    verification_link_tag.remove()
    verification_result_tag.html(`\
<div class='light-grey'> \
<i class='far fa-spinner-third fa-spin'></i> ${i18n.t("js.front.domain_search.verifying")} \
</div>`).css({ display: "inline-block" })

    return $.ajax({
      url: App.api.verifyEmail(email),
      headers: { "Email-Hunter-Origin": "website_dashboard" },
      type: "GET",
      data: { format: "json" },
      dataType: "json",
      error(xhr, statusText, err) {
        verification_result_tag.html("")
        verification_link_tag.css({ display: "inline-block" })

        const response = JSON.parse(xhr.responseText)

        if (xhr.status === 403) {
          App.displayFlash("danger", i18n.t("js.front.api_errors.search_rate_limit_reached"))
          return

        } else if (xhr.status === 429) {
          const error_id = response.errors[0].id

          if (error_id === "restricted_account") {
            // The user account is hard frozen or blocked. He's redirected to the
            // dashboard so the backoffice takes him to the right validation/verification
            // process.
            Turbo.visit("/dashboard")
            return

          } else if (error_id === "too_many_requests") {
            App.displayFlash("danger", response.errors[0].details)
            return
          }

          App.api.checkUserAccount()
          return

        } else if ([400, 451].includes(xhr.status)) {
          App.displayFlash("danger", response.errors[0].details)
          return
        }

        return App.displayFlash(
          "danger",
          i18n.t("js.front.api_errors.internal_server_error"),
          xhr.status
        )
      },

      success(result, statusText, xhr) {
        App.analytics.track(_this.trackValue)
        App.analytics.ga_track(_this.trackGaCategoryValue, _this.trackGaActionValue)

        if (xhr.status === 202) {
          verification_result_tag.html(`\
<div class='dark-orange'> \
<i class='far fa-exclamation-triangle'></i> \
<a href='/verify/${email}' target='_blank' title='${i18n.t("js.front.domain_search.click_to_launch_verification")}'>${i18n.t("js.front.domain_search.verify_again")}</a> \
</div>`
          )

          verification_result_tag.html("")
          App.displayFlash("warning", i18n.t("js.front.domain_search.verification_too_long"))
          return

        } else if (xhr.status === 222) {
          verification_result_tag.html("")
          App.displayFlash("warning", result.errors[0].details)
          return

        } else {
          if (result.data.result === "deliverable") {
            verification_result_tag.html(`<div class='green'>${App.components.verificationIcon(result.data.status, result.data.score)}
                <a href='/verify/${email}' target='_blank' title='${i18n.t("js.front.domain_search.click_to_see_check_result")}'>${i18n.t("js.verification_status.valid")}</a></div>`)
          } else if (result.data.result === "risky") {
            if (result.data.accept_all === true) {
              verification_result_tag.html(`<div class='dark-orange'>${App.components.verificationIcon(result.data.status, result.data.score)}
                  <a href='/verify/${email}' target='_blank' title='${i18n.t("js.front.domain_search.click_to_see_check_result")}'>${i18n.t("js.verification_status.accept_all")}</a></div>`)
            } else {
              verification_result_tag.html(`<div class='light-grey'>${App.components.verificationIcon(result.data.status, result.data.score)}
                  <a href='/verify/${email}' target='_blank' title='${i18n.t("js.front.domain_search.click_to_see_check_result")}'>${i18n.t("js.verification_status.unknown")}</a></div>`)
            }
          } else {
            verification_result_tag.html(`<div class='red'>${App.components.verificationIcon(result.data.status, result.data.score)}
                <a href='/verify/${email}' target='_blank' title='${i18n.t("js.front.domain_search.click_to_see_check_result")}'>${i18n.t("js.verification_status.invalid")}</a></div>`)
          }

          // Activate tooltip on icon
          App.tooltip(verification_result_tag[0].querySelectorAll("[data-bs-toggle='tooltip']"))
        }
      }
    })
  }
}
